/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketseventvatusual3Inputs */

const en_ticketseventvatusual3 = /** @type {(inputs: Ticketseventvatusual3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As usual`)
};

const de_ticketseventvatusual3 = /** @type {(inputs: Ticketseventvatusual3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie sonst auch`)
};

/**
* | output |
* | --- |
* | "As usual" |
*
* @param {Ticketseventvatusual3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketseventvatusual3 = /** @type {((inputs?: Ticketseventvatusual3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketseventvatusual3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketseventvatusual3(inputs)
	return de_ticketseventvatusual3(inputs)
});
export { ticketseventvatusual3 as "ticketsEventVatUsual" }